enum TranslationModule {
    COMMON = 'front_common',
    AGREEMENT = 'front_agreement',
    FRONT_MESSAGING = 'front_messaging',
    ROOM = 'front_room',
    VALIDATION = 'front_validation',
    BENEFIT = 'front_benefit',
    MEMBER = 'front_member',
    RELATIONSHIP = 'front_relationship',
    EVENT = 'front_event',
    WORKSPACE = 'front_workspace',
    HUB = 'front_hub',
    CLUB = 'front_club',
    PAYMENT_METHODS = 'front_payment_methods',
    MEMBERSHIP = 'front_membership',
    TRIP_PLANNER = 'front_trip_planner',
    SPONSORSHIP = 'front_sponsorship',
    COMPANY = 'front_company',
    PUBLIC_LOGIN = 'public_login',
    APPLY = 'public_apply',
    HOME = 'front_homepage',
}

export default TranslationModule
